/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { LocationGroupsResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class LocationGroups<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetLocationGroups
   * @request GET:/locationGroups
   * @secure
   */
  getLocationGroups = (params: RequestParams = {}) =>
    this.request<LocationGroupsResponse, any>({
      path: `/locationGroups`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsLocationGroups
   * @request OPTIONS:/locationGroups
   */
  optionsLocationGroups = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/locationGroups`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsLocationGroups2
   * @request OPTIONS:/locationGroups/{id}
   * @originalName optionsLocationGroups
   * @duplicate
   */
  optionsLocationGroups2 = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/locationGroups/${id}`,
      method: 'OPTIONS',
      ...params,
    });
}
